'use client';
import { useState } from 'react';
import { Text, VStack } from '@chakra-ui/react';

import SliderControls from 'shared/SliderControls';
import { useSwiperControls } from 'shared/hooks';
import MentorCard from './MentorCard';
import Slider from 'shared/Slider';

import { SECTIONS_IDS } from 'constants/global';
import { mentorsCardsData } from 'constants/mentors';

const Mentors = () => {
  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  return (
    <VStack
      as="section"
      id={SECTIONS_IDS.mentors}
      w="full"
      gap={{ mobile: '40px', tablet: '60px' }}
      px={{ mobile: '16px', tablet: '40px', laptop: '80px' }}
    >
      <VStack color="ourWhite" textAlign="center" gap={{ mobile: '20px', laptop: '24px' }}>
        <Text as="h2" hideBelow="tablet" textTransform="uppercase">
          Менторы <br /> «Траектории лидерства»
        </Text>
        <Text as="h2" hideFrom="tablet" textTransform="uppercase" maxW="515px">
          Менторы «Траектории лидерства»
        </Text>

        <Text textStyle="h5" maxW={{ laptop: '980px' }}>
          Руководители ASTON, рядом с которыми ты будешь расти
        </Text>
      </VStack>

      <VStack w="full" gap="32px">
        <SliderControls alignSelf="end" {...controls} />

        <Slider
          controller={swiper}
          setController={setSwiper}
          slidesData={mentorsCardsData}
          SlideComponent={MentorCard}
        />
      </VStack>
    </VStack>
  );
};

export default Mentors;
